import { useLmcUserView } from "../../../../contexts/AuthContext";

const useIsAuthenticate = () => {
  const { state } = useLmcUserView();

  return state.auth.isAuthenticated;
};

export default useIsAuthenticate;
